export const LEDGER_PERSPECTIVE = Object.freeze({
  CUSTOMER: "customer",
  ADMIN: "admin",
});

export const toAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? Math.abs(amount) : 0;
};

const normalizeItem = (item) =>
  String(item || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const isMoneyReceived = (item) =>
  ["money received", "money recieved", "receive money"].includes(item);

const isMoneyGiven = (item) =>
  ["money given", "give money"].includes(item);

export const getTransactionContribution = (
  item,
  amount,
  perspective = LEDGER_PERSPECTIVE.CUSTOMER,
) => {
  const normalizedItem = normalizeItem(item);
  const normalizedAmount = toAmount(amount);

  if (normalizedItem === "feed" || normalizedItem === "ghee") {
    return -normalizedAmount;
  }

  if (isMoneyReceived(normalizedItem)) {
    return perspective === LEDGER_PERSPECTIVE.ADMIN
      ? normalizedAmount
      : -normalizedAmount;
  }

  if (isMoneyGiven(normalizedItem)) {
    return perspective === LEDGER_PERSPECTIVE.ADMIN
      ? -normalizedAmount
      : normalizedAmount;
  }

  return 0;
};

export const calculateLedgerBalance = (
  {
    openingBalance = 0,
    milk = 0,
    feed = 0,
    ghee = 0,
    moneyReceived = 0,
    moneyGiven = 0,
  },
  perspective = LEDGER_PERSPECTIVE.CUSTOMER,
) => {
  const contributions = {
    milk: toAmount(milk),
    feed: -toAmount(feed),
    ghee: -toAmount(ghee),
    moneyReceived: getTransactionContribution(
      "Money Received",
      moneyReceived,
      perspective,
    ),
    moneyGiven: getTransactionContribution(
      "Money Given",
      moneyGiven,
      perspective,
    ),
  };

  const activity = Object.values(contributions).reduce(
    (total, amount) => total + amount,
    0,
  );
  const opening = Number(openingBalance);
  const safeOpening = Number.isFinite(opening) ? opening : 0;

  return {
    openingBalance: safeOpening,
    activity,
    closingBalance: safeOpening + activity,
    contributions,
  };
};
